import { handleRequest } from './base';

// APIKeyRepo is used to retrieve and store API Keys
const APIKeyRepo = {
  fetchCollection: (business) => handleRequest({
    method: 'get',
    url: `/business/${business.id}/api-keys`,
  }),

  create: (business, apiKey) => handleRequest({
    method: 'post',
    url: `/business/${business.id}/api-keys`,
    data: apiKey,
  }),
};

export default APIKeyRepo;
